import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { AssetMapWorkspace } from "@/features/map";
import {
	type MapViewSearch,
	mapViewSearchSchema,
} from "@/features/map/lib/map-view-search";
import { assetInstanceQueryOptions } from "@/services/asset";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets/$assetId/workspace/map",
)({
	component: AssetWorkspaceMapTab,
	validateSearch: (search): MapViewSearch => mapViewSearchSchema.parse(search),
});

function AssetWorkspaceMapTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets/$assetId/workspace/map",
	});
	const assetById = useQuery(
		assetInstanceQueryOptions.detail(params.assetId, {
			organizationId: params.orgId,
		}),
	);

	return (
		<AssetMapWorkspace
			orgId={params.orgId}
			assetId={params.assetId}
			asset={assetById.data}
			isAssetPending={assetById.isPending}
		/>
	);
}
